export default __webpack_public_path__ + "d0b4da0db4a4241be0ede2958b4087c5.png";